// The page's first script, before the app's code (vite.config.ts): see lib/startup-boot.ts.
import { installStartupReads } from "./lib/startup-boot";

installStartupReads(window, localStorage);
